import { get } from '../../utils/api';
import { User } from '../account/types';
const endpoint = '/api/account/representatives';

export async function getAllRepresentatives(): Promise<User[]> {
    return get<Promise<User[]>>(endpoint);
}